import React from 'react';

import Hero from '../components/Hero/Hero';
import TrustStrip from '../components/TrustStrip/TrustStrip';
import ProcessSteps from '../components/ProcessSteps/ProcessSteps';
import NavigateServices from '../components/NavigateServices/NavigateServices';
import PromotionBanner from '../components/PromotionBanner/PromotionBanner';
import SummerCampaignSection from '../components/SummerCampaign/SummerCampaignSection';
import Counter from '../components/Home/Counter';
import ReasonPart from '../components/ReasonPart/ReasonPart';
import ServiceAreas from '../components/ServiceAreas/ServiceAreas';
import CustomerComments from '../components/CustomerComment/CustomerComment';
import HomeTrust from '../components/Home/HomeTrust';
import HomeFAQ from '../components/Home/HomeFAQ';
import CTABanner from '../components/CTABanner/CTABanner';
import PageSEO from '../components/SEO/PageSEO';
import { isCampaignActive } from '../Data/campaignConfig';

import '../pagesStyles/home.css';

const Home = () => {
  const campaignActive = isCampaignActive();

  return (
    <>
      <PageSEO pageKey="home" />
      <Hero />
      <SummerCampaignSection />
      <TrustStrip />
      <ProcessSteps />
      <NavigateServices />
      {!campaignActive && <PromotionBanner />}
      <Counter />
      <ReasonPart />
      <ServiceAreas />
      <CustomerComments />
      <HomeTrust />
      <HomeFAQ />
      <CTABanner />
    </>
  );
};

export default Home;
